import { indentedListToTree } from '../store/migrations/data-structure-conversion'

const indentedTutorial = [
    {
        id: 'yeshi7tcddqdi1qvo2jaxu1koe5pj1',
        type: 'checkbox',
        text: 'How to use Treelist?',
        indentation: 0
    },
    {
        id: 'fhgx02n4ysdyc9wizs8oyo7f77s8n3',
        type: 'text',
        text: 'Welcome! This tutorial is in a todo-list form. Hopefully it will be easy to understand!',
        indentation: 1
    },
    {
        id: '4d232el5ieiuljc8wiet2ymnmpr6uv',
        type: 'text',
        text: 'You can navigate in Treelist using arrow keys (up/down/right/left)',
        indentation: 1
    },
    {
        id: '6wrkxcykv35dyx0b5kp9oq3of7xgtr',
        type: 'checkbox',
        text: 'Basic tutorial (read this before using the app)',
        indentation: 1
    },
    {
        id: 'k511su9lv3ogunw1o1i6avxl1tm22z',
        type: 'text',
        text: "First of all, in Treelist, all tasks are lists and all lists are tasks. It's like a tree (wow, didn't see this coming?) or like folders on your computer.",
        indentation: 2
    },
    {
        id: '7h4bjoel03vna5q5zrd8a9vyi476aw',
        type: 'text',
        text: 'Some features work only on the keyboard at the moment',
        indentation: 2
    },
    {
        id: '2n92tn0e4vmn0knaruthp8fpskf2j4',
        type: 'text',
        text: 'Reordering items',
        indentation: 3
    },
    {
        id: 'wg3w3213y4icunb2p964exdaqrx6il',
        type: 'text',
        text: 'Changing task type to other than todo/done',
        indentation: 3
    },
    {
        id: '4hwwkbufdaj2kecutur8esjjcqaa5c',
        type: 'checkbox',
        text: 'To Do & Done',
        indentation: 2
    },
    {
        id: 'ujbfp3254pkvytd3fqwxrv2utkxmam',
        type: 'checkbox',
        text: 'This is a To Do',
        indentation: 3
    },
    {
        id: '7rlhukxmlxhirltmbeyd8o2fuo7y1j',
        type: 'done',
        text: 'And this is Done',
        indentation: 3
    },
    {
        id: 'ogaqauqxlurszgpanto2642o8b39no',
        type: 'checkbox',
        text: 'Click the icon to mark the task as done/undone',
        indentation: 3
    },
    {
        id: '25fnsx11tc17ke0xgwtgjv1i3hhtop',
        type: 'checkbox',
        text: 'Press space to do the same',
        indentation: 3
    },
    {
        id: 'apm1zveet0ckpc44c4qkeoe71jent7',
        type: 'text',
        text: "If you want, you can mark the tips as ”done” once you've tried them",
        indentation: 3
    },
    {
        id: '5i9pwlihxzhvey65u4x74ec48r3570',
        type: 'checkbox',
        text: 'Creating new tasks',
        indentation: 2
    },
    {
        id: 'yog921dc9t8tykkcs2h94eh1cb9dfj',
        type: 'checkbox',
        text: 'There is the plus button in the bottom of the list',
        indentation: 3
    },
    {
        id: 'apjwsy41hhls26nspt3bvdgx7f7p6r',
        type: 'checkbox',
        text: 'There is the small plus icon on the right side of tasks',
        indentation: 3
    },
    {
        id: 'u0k7fuhgy52iwmcs07pv6merz6kb6k',
        type: 'checkbox',
        text: 'When you hit enter after writing text, a new task is created below',
        indentation: 3
    },
    {
        id: 'xninwuuxlidqo6ae8frxg62bgb48cu',
        type: 'checkbox',
        text: "By ”enter” I always mean either the return key or the enter key. Our user testing has shown that most people don't know what's ”the return key” or even confuse it with backspace",
        indentation: 4
    },
    {
        id: '4pua5lusmnwrtgkidquj6k38o6ze06',
        type: 'checkbox',
        text: 'Same with delete – either backspace or delete.',
        indentation: 4
    },
    {
        id: '03ftydvj65jyp011y8rvitov0a2j7a',
        type: 'checkbox',
        text: 'You can also hold alt key and press arrow key to any direction',
        indentation: 3
    },
    {
        id: 'spk2793gpwhn5qhihx4i9qczx97yk9',
        type: 'checkbox',
        text: 'Deleting tasks',
        indentation: 2
    },
    {
        id: '26hpjypfn38c8pan5ge58hm1f8vibw',
        type: 'text',
        text: 'There is no undo yet – so be careful!',
        indentation: 3
    },
    {
        id: 'xwljw7wof6mxvgfjna82eduh2w8l8u',
        type: 'checkbox',
        text: 'Press delete to delete a task',
        indentation: 3
    },
    {
        id: 'w9i2esjjm6y1bgnleh1q8eq7s464ib',
        type: 'checkbox',
        text: 'Yup, you can also use backspace, if you know what that is.',
        indentation: 4
    },
    {
        id: 'awjhhlch5q5l3l0jw1oeghavtl4uv3',
        type: 'text',
        text: "You can't delete tasks with subtasks though – this is to prevent you from accidentally losing lots of information",
        indentation: 3
    },
    {
        id: 'oeqq3q97d7c9q2di5vyfassqr8wuvq',
        type: 'checkbox',
        text: 'Try deleting me',
        indentation: 3
    },
    {
        id: 'z4n8f8d6fb49700h9tzrv8elj7ku08',
        type: 'text',
        text: 'Not going to work once this subtasks is here!',
        indentation: 4
    },
    {
        id: 'ynafxuf38if4cjgddcxlu0ceazclvf',
        type: 'checkbox',
        text: 'Changing order',
        indentation: 2
    },
    {
        id: '3s9vk63oyfmj7otvl9nxzihs5tnape',
        type: 'checkbox',
        text: 'Press ctrl to grab a task. Then move it with different arrow keys',
        indentation: 3
    },
    {
        id: 'vnqr1px68uqkd5g5247faqcpzbs4s1',
        type: 'text',
        text: 'Moving a task to the right only works if there is another task on top of it',
        indentation: 3
    },
    {
        id: '481bba6w2kwrrxwssmo7hoj51tlltr',
        type: 'checkbox',
        text: 'More task types',
        indentation: 2
    },
    {
        id: 'm472lahpfk8eatt8cpuevbw7v5sq56',
        type: 'text',
        text: 'You can change between todo and done with space, but Treelist has a lot of other states as well',
        indentation: 3
    },
    {
        id: '8p1uyup6hj9pc5oygvzmbvs0cq3cub',
        type: 'checkbox',
        text: 'To Do',
        indentation: 3
    },
    {
        id: 'dymepzcverv2da20ta2mn7syluemtq',
        type: 'checkbox',
        text: 'Press A to change a task to To Do (this is already a To Do so nothing will happen)',
        indentation: 4
    },
    {
        id: '77mmc18rrfhpm2koi4rms8eh54na5y',
        type: 'text',
        text: 'Not much interesting here. If you have ever used a to-do list, you know the drill.',
        indentation: 4
    },
    {
        id: 'uwa1n1lw2wfmcscqeqodbipi1mz8si',
        type: 'checkbox',
        text: 'Done',
        indentation: 3
    },
    {
        id: 'kk85sfbdpjostaojmun2ibscnwrrsj',
        type: 'checkbox',
        text: 'Press D to change a task to Done',
        indentation: 4
    },
    {
        id: 'hgm6yjo781eisorep8jf6h3lf9knl5',
        type: 'text',
        text: 'You might have noticed that the Done state is visually quite exaggerated. This one of the core philosophies of Treelist – try to think how good you are in doing things, rather than how many things you have not done yet.',
        indentation: 4
    },
    {
        id: '5l5pepnswc54ijljdyir23gmd53wsj',
        type: 'text',
        text: "You can't hide dones. Some people say this is annoying, but this is deliberate. You should remember what you've accomplished! Just move the dones to the top of the list to be out of the way",
        indentation: 4
    },
    {
        id: 'vfsyfmwc2imnwqyqnsx7um9iluts31',
        type: 'checkbox',
        text: 'Description',
        indentation: 3
    },
    {
        id: 'mn3r2une0tghx05syrsa1urqv9oshb',
        type: 'checkbox',
        text: 'Press E to change a task to Description',
        indentation: 4
    },
    {
        id: 'jkyakoqyuxk37e2nqi2e9y96c8vicx',
        type: 'text',
        text: 'These provide extra information, but are not calls for action. Descriptions work like other tasks, they just look different.',
        indentation: 4
    },
    {
        id: 'diemil5sstokosfofxpm8e2xkpglyh',
        type: 'text',
        text: "It's useful if you have lot of details to write, but you want to keep the task title short and snappy",
        indentation: 4
    },
    {
        id: 'o65l7vz345ipofs7lhowwd2mrhml5n',
        type: 'text',
        text: 'You can also use these for just making notes',
        indentation: 4
    },
    {
        id: 'ecgakjxve1vhbr9be2eyydajltkm41',
        type: 'checkbox',
        text: 'Idea',
        indentation: 3
    },
    {
        id: 'b6g7orflqfcf6hyuy6ijj9utuk36jz',
        type: 'checkbox',
        text: 'Press Q to change a task to Idea',
        indentation: 4
    },
    {
        id: 'd1xwfxc6ct5juqjvkib0hrlz7spqwt',
        type: 'text',
        text: "Ideas are like To Dos, but you are not yet sure if you want to do them or not. **It's okay if you end up not doing them.**",
        indentation: 4
    },
    {
        id: '2v7a4d1ergqmopba69r0hsu36uy34s',
        type: 'text',
        text: 'yes, markdown',
        indentation: 5
    },
    {
        id: 'tefimdz2ngbetbn7yg4blar9fhbo33',
        type: 'text',
        text: 'The main idea is that your list has the minimum number of "hey please remember me right now!" things visible. Same reason we have the whole hiearchy thing.',
        indentation: 4
    },
    {
        id: '6akrr3f5l57l2fise7kq1islyz40z5',
        type: 'checkbox',
        text: 'Cancelled',
        indentation: 3
    },
    {
        id: '4iui4a4g0grdkdxog4wadmnwln11ax',
        type: 'checkbox',
        text: 'Press C to change a task to Cancelled',
        indentation: 4
    },
    {
        id: 'c14gh383f8rls5buackwlap8biw7bt',
        type: 'text',
        text: 'While you can just remove your task from the list if you are not going to do it, sometimes you are only 99% sure and it can be handy to keep the task around.',
        indentation: 4
    },
    {
        id: 'ujodwsmx0tj33v4ou84erc29kz226k',
        type: 'text',
        text: 'Cancelled might also help with the feeling "did I forget something?"',
        indentation: 4
    },
    {
        id: 'rv11wi8dvo4zofboghqblfq9apsk7t',
        type: 'checkbox',
        text: 'Waiting',
        indentation: 3
    },
    {
        id: 'wka1w8u3bjqvsd7m35rohev33i0uln',
        type: 'checkbox',
        text: 'Press W to change a task to Waiting',
        indentation: 4
    },
    {
        id: 'zbr7isi98kjeimfyu179hiacblv2hl',
        type: 'text',
        text: "Something that needs to happen, but you can't do anything about it right now. For example waiting for a response from someone.",
        indentation: 4
    },
    {
        id: 'fppbusup7vqzv021mmcyxfl48d72dp',
        type: 'checkbox',
        text: 'Difficult',
        indentation: 3
    },
    {
        id: 'khfd3aje91je328tedx7lpc3mv221k',
        type: 'checkbox',
        text: 'Press F to change a task to Difficult',
        indentation: 4
    },
    {
        id: 'm3ymf86trujqzrj7hfjyvolzal29lw',
        type: 'text',
        text: 'If there is ever anything that makes you want to not even open the to-do list, set it to Difficult',
        indentation: 4
    },
    {
        id: '46s2yztfehil4c2kjh4w7plg994h4x',
        type: 'text',
        text: 'Summary',
        indentation: 3
    },
    {
        id: '8wf2zsvr0c26kn72xnth3r1i2p740o',
        type: 'checkbox',
        text: 'To do (A)',
        indentation: 4
    },
    {
        id: 'jiy87stjezhi4despgf7dhflindqll',
        type: 'done',
        text: 'Done (D)',
        indentation: 4
    },
    {
        id: 'u3icb5rnmdfbnl11ngaqv9r1rx760x',
        type: 'text',
        text: 'Description (E)',
        indentation: 4
    },
    {
        id: 'y6zaoc1cqjwoftfpvpcuokg5fjn8nr',
        type: 'idea',
        text: 'Idea (Q)',
        indentation: 4
    },
    {
        id: 'kqendqy7a0d6me67guaiwqiou9n6vp',
        type: 'cancelled',
        text: 'Cancelled (C)',
        indentation: 4
    },
    {
        id: 'zevkutv3avizlilo23by4zdxae7x18',
        type: 'waiting',
        text: 'Waiting (W)',
        indentation: 4
    },
    {
        id: 'kd40pmkb6mspmezisbp39p60i79p67',
        type: 'failed',
        text: 'Difficult (F)',
        indentation: 4
    },
    {
        id: '83jef9uveq412y98otf85pb4lxjjae',
        type: 'text',
        text: "Pressing space does exactly the same thing as pressing D or A. It's just a shortcut.",
        indentation: 3
    },
    {
        id: 'b42xq44t1tre7581wavh67y97rgmh3',
        type: 'waiting',
        text: 'Advanced tutorial (read this once you have mental space for new info)',
        indentation: 1
    },
    {
        id: '8cbjcla1zjp2udd48r4iyhpbsct2aa',
        type: 'checkbox',
        text: 'More ergonomic shortcuts',
        indentation: 2
    },
    {
        id: 'xoh1z8nlxckwsqtfof7zz4kfxcp780',
        type: 'checkbox',
        text: 'Creating tasks with specific types',
        indentation: 3
    },
    {
        id: 'v0kejwry3adfj99p9k7bboj606rz76',
        type: 'checkbox',
        text: 'Press and hold a type key (A/Q/W/D/C/F/E) and then press arrow key',
        indentation: 4
    },
    {
        id: 'naqq24j1lmasbc8f5dnfkecjridrow',
        type: 'checkbox',
        text: 'Or: Press and hold a type key (A/Q/W/D/C/F/E) and then press enter',
        indentation: 4
    },
    {
        id: '0i0271nr983az290v1ue81dkczwf87',
        type: 'checkbox',
        text: 'Shortcut for moving tasks left/right',
        indentation: 3
    },
    {
        id: '9h8bz3x6krrydqciyppk1omtt2hkfz',
        type: 'checkbox',
        text: 'Indent with tab (the key in the left of Q)',
        indentation: 4
    },
    {
        id: '96691g9qbegb4xokjei9muc0srv4gu',
        type: 'checkbox',
        text: 'Hold shift while pressing tab to do the opposite',
        indentation: 4
    },
    {
        id: 'egkmk2mgeupgfrql32hr8fijemsae3',
        type: 'text',
        text: 'Just like if these were bullet points in a text editor',
        indentation: 4
    },
    {
        id: 'env0zga6ykhdu8jmcgsz8p6mqnygtj',
        type: 'checkbox',
        text: 'Some markdown features',
        indentation: 2
    },
    {
        id: 'j94cvh0mg284qnthe3ajbyl9pz1s3l',
        type: 'text',
        text: "Edit the text in the items below to see how it's made",
        indentation: 3
    },
    {
        id: 'fo21u5jedq288lljhtwcti84hajgat',
        type: 'checkbox',
        text: '*italics* _italics_',
        indentation: 3
    },
    {
        id: 'ru2pphhfdk2uk6vzn1cq5mlggsoalx',
        type: 'checkbox',
        text: '**bold** __bold__',
        indentation: 3
    },
    {
        id: 'pryqhyhuylz8xk2mo1th1612krjnip',
        type: 'checkbox',
        text: '~~strikethrough~~',
        indentation: 3
    },
    {
        id: 'p3zkqhwq2hi2w7ox7ja3z8icye3if8',
        type: 'checkbox',
        text: '`monospace`',
        indentation: 3
    },
    {
        id: 'rvkei87vvfqq798iso4o4yx71vl6bh',
        type: 'checkbox',
        text: '[Links](https://treelist.app)',
        indentation: 3
    },
    {
        id: 'fkb2b8acmjkrardqa5nheat0n9724d',
        type: 'text',
        text: 'Design Philosophy',
        indentation: 2
    },
    {
        id: 'vw5q9mnipbt1t8om8h1t2tgcqw75ph',
        type: 'text',
        text: 'Offline',
        indentation: 3
    },
    {
        id: '2jxb050s9agtjchf3b5vaf6rcwz8fl',
        type: 'text',
        text: "If you didn't notice yet, Treelist works in 100% offline.",
        indentation: 4
    },
    {
        id: '4lesmywszwua83hf2nahs567letrcx',
        type: 'text',
        text: 'You can even close the tab, turn off your internet connection and then type treelist.app to the browser. If your browser is new enough, it will open the app.',
        indentation: 4
    },
    {
        id: 'anti7a0bpsnv2fezdn9g91kb5ybxi6',
        type: 'text',
        text: 'Minimum interventions for the user',
        indentation: 3
    },
    {
        id: '6rdbuf4sel45wp0azpdbhnff92m1pk',
        type: 'text',
        text: 'Mandatory registration is stupid when there is no reason.',
        indentation: 4
    },
    {
        id: '6swyy4m1xzgd0uvo36wjrb5is5rpzz',
        type: 'text',
        text: 'We will make functinoality to sync the list between different devices at some point. Then you will need to log in. Otherwise there is no need.',
        indentation: 5
    },
    {
        id: 'sjx9xxch9d3dvy00x18dqw7l5pwq0x',
        type: 'text',
        text: "Did you notice that we didn't have any cookie consent box? That's because we don't give you cookies before you log in. Anything to make your experience better.",
        indentation: 4
    },
    {
        id: '0ipai6c7isk2z2vhuirhz2ed4wkiue',
        type: 'text',
        text: 'Wanna subscribe to our newsletter? You can find it at https://t.me/treelistnews',
        indentation: 4
    },
    {
        id: '4xvjhwxdvh5opwh5nnyobosfeciyzx',
        type: 'text',
        text: "No we don't serve ads. We might make the cloud sync a paid-only feature",
        indentation: 4
    },
    {
        id: 'pb5uwr72ucs7f9aourn1z72li5vst6',
        type: 'text',
        text: 'Ultra responsive',
        indentation: 3
    },
    {
        id: 'lg5f7v331xr91r0iw0yw9llqlzyois',
        type: 'text',
        text: "Have you noticed how the app doesn't lag at all?",
        indentation: 4
    },
    {
        id: 'v1amnz6wclmwo2eoc9s2bu7u9zuyhh',
        type: 'text',
        text: 'Have you used other websites this responsive?',
        indentation: 4
    },
    {
        id: 'ovnxfexl6nsef24w1fpz63rrbh42nu',
        type: 'text',
        text: 'We carefully consider the responsivity after each update. [Google says 100 milliseconds feels immediate.](https://web.dev/rail/) We disagree, and we try to keep most interactions under 16 ms.',
        indentation: 4
    },
    {
        id: '0iok8phrw8d7jsuy0uluj9cbmkcwas',
        type: 'text',
        text: 'Features',
        indentation: 2
    },
    {
        id: '3m1yhgnfwe386pyx5hntix25jr6u4q',
        type: 'text',
        text: 'Mouse support?',
        indentation: 3
    },
    {
        id: 'o0h8u35v9shiqyzmol0oh14g4259v2',
        type: 'text',
        text: 'Yes, eventually',
        indentation: 4
    },
    {
        id: '2xuxgt4hik8zwzq0mc98vlf9hx50tp',
        type: 'text',
        text: 'Yes, we consider it high priority',
        indentation: 4
    },
    {
        id: 'wz2kcrxki1oht2akzp1btxnkvsg28p',
        type: 'text',
        text: "Why can't I see multiple levels of the hierarchy at once?",
        indentation: 3
    },
    {
        id: 't4gsh7lyxy37d28leurbffb5j900ll',
        type: 'text',
        text: 'Because you should focus on tasks in just one layer. This helps you decide where to put each task.',
        indentation: 4
    },
    {
        id: 'b3qu0jp12rf79az1wgzwledfqrwtlm',
        type: 'text',
        text: "If you want to see everything, then just don't make a hierarchy!",
        indentation: 4
    },
    {
        id: 'lmuwdvh4m1fupjnzhfcbxd4xqy5fav',
        type: 'text',
        text: 'Cloud functionality?',
        indentation: 3
    },
    {
        id: '7kajb47gqn14pbxxsl6fousdlc2atv',
        type: 'text',
        text: 'Yes, there will be',
        indentation: 4
    },
    {
        id: 'vc6emr6cfrzulzbz7nfwjifiggz1gh',
        type: 'text',
        text: "It's harder than normal when we have 100% offline support. What should happen when two browsers make different edits while both offline?",
        indentation: 4
    },
    {
        id: 'ielk1szihoeyuv224v0dqyzxy9uu63',
        type: 'text',
        text: 'Embedded media?',
        indentation: 3
    },
    {
        id: 'twxpzzxh23fsf1ccguqrfrlyj4zgmu',
        type: 'text',
        text: 'Probably at some point. Large filesizes might make this difficult though.',
        indentation: 4
    },
    {
        id: 'templeuzakbze73png878p6e0bikr1',
        type: 'text',
        text: 'This is the end of the tutorial. Thank you for reading it! Have fun! :)',
        indentation: 2
    }
]

export const tutorial = indentedListToTree(indentedTutorial)
